<template>
  <div class="login-logo">
    <img
      v-if="$vuetify.theme.name === 'light'"
      alt=""
      role="presentation"
      aria-label="TubeWay logo"
      width="180px"
      src="../../../assets/images/tw-login-logo-light.png"
    />
    <img
      v-if="$vuetify.theme.name === 'dark'"
      alt=""
      role="presentation"
      width="180px"
      src="../../../assets/images/tw-login-logo-dark.png"
    />
  </div>
</template>

<script>
export default {
  name: "LoginLogo"
}
</script>
